<template>
    <div class="g fieldset">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .g.fieldset::v-deep {

        + .g.fieldset {
            margin-top: $interval-xs;
        }
    }
</style>
